import { render, staticRenderFns } from "./micoapp.vue?vue&type=template&id=42c91528&"
import script from "./micoapp.vue?vue&type=script&lang=js&"
export * from "./micoapp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports